import moment from 'moment';

export class PTProgram {
	public guid: string = '';
	public name: string = '';
	public exerciseCount: number = 0;
	public lastUpdate: moment.Moment = moment();
	public printTemplateName: string = '';
	public validFromUtc: moment.Moment = moment();
	public validToUtc: moment.Moment = moment();
	public status: number = 0;
	public previous_Guid: string = '';
	public iid: number = 0;
	public accessRights: number = 0;
	public visibility: number = 0;
	public authorId: number = 0;
	public authotOrganizationId: number = 0;
	public authorCultureTag: string = '';
	public authorUtcOffsetTag: number = 0;

	static fromJson(json: any): PTProgram | undefined {
		if (typeof json === 'object')
		{
			const p = new PTProgram();
			p.guid = json.guid;
			p.name = json.name;
			p.exerciseCount = json.exerciseCount;
			p.lastUpdate = moment.utc(json.lastUpdate);
			p.printTemplateName = json.printTemplateName;
			p.validFromUtc = moment.utc(json.validFromUtc);
			p.validToUtc = moment.utc(json.validToUtc);
			p.status = json.status;
			p.previous_Guid = json.previous_Guid;
			p.iid = json.iid;
			p.accessRights = json.accessRights;
			p.visibility = json.visibility;
			p.authorId = json.authorId;
			p.authotOrganizationId = json.authorOrganizationId;
			p.authorCultureTag = json.authorCultureTag;
			p.authorUtcOffsetTag = json.authorUtcOffsetTag;
			return p;
		}
	}
}